import * as dompack from 'dompack';
import { Element, Class } from "@webhare-system/frameworks/mootools/core";

var $todd = require("./support");
require("./images");

const bgstyle = Symbol("background style");

// Set the node's background color and images, based on the component's backgroundcolor resp. backgroundimages properties
function updateNodeBackground(node, backgroundcolor, backgroundimages)
{
  // Save styling information
  if (!node[bgstyle])
    node[bgstyle] = { node: null // The node's <style> node
                    , width: 0   // Width of the "fit" background image
                    , height: 0  // Height of the "fit" background image
                    };
  else if (node[bgstyle].node)
  {
    node.removeChild(node[bgstyle].node);
    node[bgstyle].node = null;
  }
  // Make sure the node has an id, so it can be referred to in the <style>
  if (!node.id)
    node.id = "bgstyle-" + Math.random().toString(36).substr(2);
  let styleNode = document.createElement("style");

  if (backgroundcolor)
    styleNode.appendChild(document.createTextNode(`#${node.id}{background-color:${$todd.fixupColor(backgroundcolor)};}`));
//    node.setStyle("background-color", $todd.fixupColor(backgroundcolor));

  if (backgroundimages && backgroundimages.length)
  {
    let images = [];
    let sizes = [];
    let positions = [];
    let repeats = [];
    node[bgstyle].width = 0;
    node[bgstyle].height = 0;
    let fitIdx = -1; //ADDME: Only one "fit" image is supported now (but it's only used by imgedit for now)
    backgroundimages.forEach((img, idx) =>
    {
      if (img.src)
      {
        images.push("url('" + img.src + "')");
        if (img.size.indexOf("fit") === 0)
        {
          // For the "fit" size, the width and height of the background image are specified, so the background-size can be
          // set to "auto" if the node is big enough, or to "contain" if the background image should be scaled down (we don't
          // want it scaled up)
          // It would be nice if CSS would have a "fit" background-size that only scales down, or if we could have media-like
          // queries for elements instead of the whole document
          let size = img.size.split("|");
          if (size.length == 3)
          {
            node[bgstyle].width = parseInt(size[1], 10);
            node[bgstyle].height = parseInt(size[2], 10);
            fitIdx = idx;
            img.size = "auto";
          }
          else
            img.size = "contain";
        }
        sizes.push(img.size ? img.size : "auto");
        positions.push(img.position.length ? img.position.join(" ") : "center");
        repeats.push(img.repeat ? img.repeat : "repeat");
      }
    });
    if (images.length)
    {
      styleNode.appendChild(document.createTextNode(`#${node.id}{`
          + `background-image:${images.join(",")};`
          + `background-size:${sizes.join(",")};`
          + `background-position:${positions.join(",")};`
          + `background-repeat:${repeats.join(",")};`
          + `}`));
      if (fitIdx >= 0 && (node[bgstyle].width || node[bgstyle].height))
      {
        sizes[fitIdx] = "contain";
        // By adding the "bgstyle-responsive" class to the node if it's not big enough to display the whole background image,
        // the background image is resized to fit
        styleNode.appendChild(document.createTextNode(`#${node.id}.bgstyle-responsive{`
            + `background-size:${sizes.join(",")};`
            + `}`));
      }
    }
  }

  if (styleNode.childNodes.length)
  {
    node.appendChild(styleNode, node);
    node[bgstyle].node = styleNode;
  }
}


/****************************************************************************************************************************
 *                                                                                                                          *
 *  PANEL                                                                                                                   *
 *                                                                                                                          *
 ****************************************************************************************************************************/


$todd.ObjPanel = new Class(
{ Extends: $todd.ObjLayout
, componenttype: "panel"
, isbodypanel: false
, spacers: {}
, borders: {}
/*
, topborder: false
, rightborder: false
, bottomborder: false
, leftborder: false
*/
, childrencalcheight: 0 //calculated height of children. we'll apply this when scrolling
, vscroll: false
, isfooter: false

  // Saved minwidth/height for scroll (when scrolling, the minwidth/height is overwritten with 32)
, realminwidth: 0
, realminheight: 0

/****************************************************************************************************************************
* Initialization
*/

, initialize: function(parentcomp, data, replacingcomp)
  {
    this.parent(parentcomp, data, replacingcomp);
    this.backgroundcolor = data.backgroundcolor;
    this.backgroundimages = data.backgroundimages;
    this.visibleons = data.visibleons||[];
    this.isfooter = data.isfooter;

    this.framename = data.frame;
    if(this.framename)
      this.owner.addComponent(this, this.framename);

    this.vscroll = data.vscroll;

    this.title = data.title;
    this.spacers = data.spacers;
    this.borders = data.borders;

    this.onDragEnter = this.onDragEnter.bind(this);
    this.onDragLeave = this.onDragLeave.bind(this);
    this.onDragOver = this.onDragOver.bind(this);
    this.onDrop = this.onDrop.bind(this);


    //ADDME can't we embed Block items directly instead of wrapping them into lines?
    this.lines = [];
    if(data.lines)
      data.lines.each(function(srcline,i)
    {
      srcline.target = this.name + "#line$" + i;
      srcline.destroywithparent = true;
      var line = new $todd.ObjPanelLine(this, srcline, null, null);
      this.lines.push(line);

      if(line.title)
      {
        var titlecomp = new $todd.ObjText(line, { value: line.title ? line.title + ':' : ''
                                                , labelfor: line.titlelabelfor
                                                , target: srcline.target + "#linelabel"
                                                , destroywithparent: true
                                                });

        if(line.layout=='form') //we need to keep the title separated
          line.titlecomp = titlecomp;
        else
          line.items.push(titlecomp);
      }

      if(srcline.items)
        srcline.items.each(function(srcitem, idx)
      {
        var newcomp;
        if (srcitem.title)
        {
          newcomp = new $todd.ObjText(line, { value: srcitem.title ? srcitem.title + ':' : ''
                                            , labelfor: srcitem.labelfor
                                            , target: srcline.target + "#label$" + idx
                                            , destroywithparent: true
                                            });
        }
        else
        {
          newcomp = this.owner.addComponent(line, srcitem.item);
        }

        if(newcomp)
        {
          line.items.push(newcomp);
        }
      }, this);
    }, this);

    if(this.parentcomp.componenttype != "split")
    {
      this.setMinToAbs(this.height);
      this.setMinToAbs(this.width);
    }

    // Build our DOM
    this.buildNode();

    this.setEnabled(data.enabled);

    this.setDropTypes(data.acceptdrops ? data.acceptdrops.accepttypes : []);
  }

, allowScroll:function()
  {
    return this.vscroll; /* rely on explicit vscroll setting
    return this.parentcomp == this.owner            // the bodynode may scroll
        || this.parentcomp.componenttype == "tabs"  // tab sheets may scroll
        || this.vscroll; */
  }

/****************************************************************************************************************************
* Component management
*/

, readdComponent: function(comp)
  {
    for(var i=0;i<this.lines.length;++i)
      if(this.lines[i].items.indexOf(comp)!=-1)
      {
        this.lines[i].readdComponent(comp);
        return;
      }
    return console.error('Child ' + comp.name + ' not inside the panel is trying to replace itself');
  }

/****************************************************************************************************************************
* Property getters & setters
*/

, setTitle: function(value)
  {
    if (value != this.title)
    {
      this.title = value;
      if (this.titlecomp)
        this.titlecomp.setValue(this.title);
    }
  }

, setDropTypes: function(droptypes)
  {
    this.droptypes = droptypes;
    if (this.droptypes.length)
    {
      this.node.addEvents({ "dragenter": this.onDragEnter
                          , "dragleave": this.onDragLeave
                          , "dragover": this.onDragOver
                          , "drop": this.onDrop
                          });
    }
    else
    {
      this.node.removeEvents({ "dragenter": this.onDragEnter
                             , "dragleave": this.onDragLeave
                             , "dragover": this.onDragOver
                             , "drop": this.onDrop
                             });
    }
  }

/****************************************************************************************************************************
* DOM
*/

  // Build the DOM node(s) for this component
, buildNode: function()
  {
    this.node = new Element("t-panel", { "data-name": this.name });
    this.node.addEventListener('mousedown', this.mouseDownNoFocusSteal.bind(this));

    this.nodearea = new Element("div", {"class":"panel-area"}).inject(this.node);
    this.node.store("todd", this);

    updateNodeBackground(this.node, this.backgroundcolor, this.backgroundimages);

    if(this.isfooter)
    {
      this.node.classList.add("isfooter");
      this.spacers = this.spacers || {};
      this.spacers.top = true;
      this.spacers.bottom = true;
    }

    Array.each(['top','bottom','left','right'], function(dir)
    {
      if(this.spacers && this.spacers[dir])
        this.node.classList.add("spacer-" + dir);
      if(this.borders && this.borders[dir])
        this.node.classList.add("border-" + dir);
    }.bind(this));

    this.lines.invoke('buildNode');
    this.lines.each(function(line) { this.nodearea.appendChild(line.node); }, this);
  }


/****************************************************************************************************************************
* Dimensions
*/
, getVisibleChildren:function()
  {
    var children=[];
    this.lines.each(function(line)
      {
        if(line.titlecomp)
        {
          children.push(line.titlecomp);
        }
      });
    children.append(this.lines);
    return children;
  }

, getLabelAreaWidth:function() //figure out the longest form-layout line label, and apply it to all lines. as labelwidth isn't open to discussion, apply immediately
  {
    // Calculate the width of the label area if we have form lines.
    var labelareawidth = 0;
    this.lines.each(function(line)
      {
        if(line.titlecomp)
        {
          if(line.titlecomp.width.min)
            labelareawidth = Math.max(labelareawidth, line.titlecomp.width.min);
        }
      });

    return labelareawidth;
  }

, calculateDimWidth: function()
  {
    // contentwidth is the width of the widest line
    var headerwidth = 0;

    //Prepare line calculation: we first need their label widths, then lines can do their actual calculations
    this.setSizeToMaxOf('width', this.lines);
    this.width.overhead = (this.spacers && this.spacers.left ? $todd.settings.spacer_left : 0) +
                        + (this.spacers && this.spacers.right ? $todd.settings.spacer_right : 0);

    this.width.min += this.width.overhead;
    this.width.calc += this.width.overhead;

    this.width.min = Math.max(this.width.min, headerwidth);
    this.width.calc = Math.max(this.width.calc, headerwidth);

    if(this.allowScroll())
    {
      this.realminwidth = this.width.min;
      this.width.min = 32;
    }


/* ADDME?
    contentwidth += this.width.marginbefore + this.width.marginafter;
    contentminwidth += this.width.marginbefore + this.width.marginafter;

    this.width.calc = Math.max(contentwidth, width);
    this.width.min = contentminwidth;
    */
  }

, applySetWidth: function()
  {
    //the inner width/height is what we present to our contents, and may exceed set width/height if we can scroll ourselves
    this.innerwidth = this.width.set - this.width.overhead;
    if (this.allowScroll() && this.width.set < this.realminwidth)
      this.innerwidth = this.realminwidth - this.width.overhead;

    var setwidth = this.innerwidth;
    this.debugLog("dimensions", "width: calc=" + this.width.calc + ", set=" + this.width.set + ", overhead=" + this.width.overhead + ", effective=" + setwidth);

    this.lines.invoke('setWidth', setwidth);
  }

, calculateDimHeight: function()
  {
    // Calculate needed size
    this.setSizeToSumOf('height', this.lines);
    this.childrencalcheight = this.height.calc;

    this.height.overhead = (this.spacers && this.spacers.top ? $todd.settings.spacer_top : 0) +
                         + (this.spacers && this.spacers.bottom ? $todd.settings.spacer_bottom : 0);

    this.height.min += this.height.overhead;
    this.height.calc += this.height.overhead;

    if(this.allowScroll())
    {
      this.realminheight = this.height.min;
      this.height.min = 32;
    }
  }

, applySetHeight: function()
  {
    this.innerheight = this.height.set - this.height.overhead;
    if(this.allowScroll() && this.height.set < this.realminheight)
      this.innerheight = this.height.calc;

    this.debugLog("dimensions", "calc=" + this.height.calc + ", set height=" + this.height.set + " ,effective=" + this.innerheight);

    this.distributeSizeProps('height', this.innerheight, this.lines, false);
  }

, relayout: function()
  {
    this.debugLog("dimensions", "relayouting set width=" + this.width.set + ", set height="+ this.height.set);

    // Set outer width, including border (we have box-sizing: border-box!)
    this.node.setStyles({width: this.width.set, height: this.height.set});
    if(this.allowScroll()) //we're creating a scrollable inner layer
    {
      // Set inner size to scrolling div
      this.nodearea.setStyles({ width:  this.innerwidth
                              , height: this.innerheight
                              });
      if (this.width.set < this.realminwidth || this.height.set < this.realminheight)
        this.node.setStyle("overflow","scroll");
      else
        this.node.setStyle("overflow","visible");
    }

    // Check if the node is big enough to display the whole background image
    if (this.node[bgstyle])
    {
      if ((this.node[bgstyle].width && this.node[bgstyle].width > this.width.set)
          || (this.node[bgstyle].height && this.node[bgstyle].height > this.height.set))
        this.node.classList.add("bgstyle-responsive");
      else
        this.node.classList.remove("bgstyle-responsive");
    }

    if (this.isbodypanel)
    {
      //FIXME should these be on node or nodearea?
/*
      this.nodearea.setStyles({ "padding-left": this.width.marginbefore
                              , "padding-right": this.width.marginafter
                              , "padding-top": this.height.marginbefore
                              , "padding-bottom": this.height.marginafter
                              });
*/
    }

    this.lines.invoke('relayout');
  }

  // ---------------------------------------------------------------------------
  //
  // Event handlers
  //

, draggingentered: 0 // A subcomponent has been entered while dragging (so we can check if we entered a new subcomponent when leaving another subcomponent)
, preventertarget: null

, onDragEnter: function(event)
  {
    if (event.target === this.preventertarget)
      return; // Entering the same element as before
    this.preventertarget=event.target;

    // Entering a(nother) subcomponent
    ++this.draggingentered;

    var res = this.owner.checkDropTarget(event, this.droptypes, this.flags, null, "ontarget");
    if (res)
    {
      event.preventDefault();
      this.node.classList.add("droptarget--hover");
    }
    return res;
  }

, onDragLeave: function(event)
  {
    if (this.draggingentered == 1) // leaving the last subcomponent, remove hover state
    {
      this.node.classList.remove("droptarget--hover");
      this.preventertarget = null;
    }
    --this.draggingentered;
  }

, onDragOver: function(event)
  {
//    this.debugLog('dimensions', 'PANEL dragover', event);
    var res = this.owner.checkDropTarget(event, this.droptypes, this.flags, null, "ontarget");
    if (res)
    {
      event.preventDefault();
      return true;
    }
  }

, onDrop: function(event)
  {
    this.node.classList.remove("droptarget--hover");
    this.preventertarget = null;
    this.draggingentered = 0;

    var dragdata = this.owner.checkDropTarget(event, this.droptypes, this.flags, null, "ontarget");
    if (!dragdata)
    {
      //this.debugLog('dimensions', 'Drop target check failed');
      return false;
    }

    $todd.uploadFilesForDrop(this, dragdata, function(msg, dialogclosecallback)
    {
      // Upload successfully (or no files)
      msg.droplocation = "ontarget";

      this.queueMessage("acceptdrop", msg, true, dialogclosecallback);
    }.bind(this));

    return true;
  }
});

/****************************************************************************************************************************
 * Single line in a panel
 */

$todd.ObjPanelLine = new Class(
{ Extends: $todd.ObjLayout
, componenttype: "panel.line"
, items: []
, titlecomp: null
, spacerswidth: 0
, gridheight: 0

, initialize: function(parentcomp, line, replacingcomp)
  {
    this.parent(parentcomp, line, replacingcomp);

    this.title = line.title || '';
    this.titlelabelfor = line.labelfor;
    this.layout = line.layout || 'form';
    this.block = line.layout == "block";
    this.gridheight = this.layout == "tabs-space" ? $todd.settings.tabspace_vsize : $todd.settings.grid_vsize;

    // Line width settings
/*    this.width = { xml_marginbefore: line.marginleft ? $todd.CalcAbsHeight(line.marginleft) : null
                 , xml_marginafter: line.marginright ? $todd.CalcAbsHeight(line.marginright) : null
                 };
*/
    // Line height settings (compatible with component dimensions record, to be used in DistributeSizes)
/*    this.height = { xml_min: 0
                  , xml_set: ""
                  , xml_marginbefore: line.margintop ? $todd.CalcAbsHeight(line.margintop) : null
                  , xml_marginafter: line.marginbottom ? $todd.CalcAbsHeight(line.marginbottom) : null
                  , min: 0
                  , calc: 0
                  , set: 0
                  };
*/
    // If margins are not explicitly given, they will be set to null
  }
, getVisibleChildren:function()
  {
    return [this.titlecomp].clean().concat(this.getVisibleItems());
  }
, getVisibleItems:function()
  {
    return this.items.filter(item => item.getVisible());
  }
, buildNode:function()
  {
    this.node = new Element("div", { "class": this.layout + (this.layout != "block" ? " line": "")
                                   });

    this.fillNode();
  }
, fillNode:function()
  {
    // Get a list of currently visible components to check if anything has changed
    var curcomponents = this.getVisibleChildren().map(function(comp)
    {
      return comp.name;
    }).join("\t");
    if (curcomponents == this.fillcomponents)
      return;

    this.fillcomponents = curcomponents;
    dompack.empty(this.node);

    if(this.layout=='form' && this.titlecomp)
      this.node.appendChild(this.titlecomp.getNode());

    dompack.append(this.node, ...this.getVisibleItems().map ( item => item.getNode() ));
  }
, getSpacersOverhead:function()
  {
    return $todd.settings.spacerwidth * ( (this.layout=='form' && this.parentcomp.getLabelAreaWidth()?1:0) + this.getVisibleItems().length - 1);
  }

, beforeRelayout: function()
  {
    // Support for simple client-side visibility
    this.fillNode();
    this.parent();
  }

, calculateDimWidth:function()
  {
    this.setSizeToSumOf('width', this.getVisibleItems(), (this.layout=='form' ? this.parentcomp.getLabelAreaWidth() : 0) + this.getSpacersOverhead());
  }

, calculateDimHeight:function()
  {
    var hcomps = this.getVisibleChildren();
    this.setSizeToMaxOf('height', hcomps);
  }

, applySetWidth:function()
  {
    var linewidth = this.width.set - this.getSpacersOverhead();
    this.debugLog("dimensions", "width: calc=" + this.width.calc + ", set=" + this.width.set, " effective width=" + linewidth);

    if(this.layout=='form')
    {
      var labelareawidth = this.parentcomp.getLabelAreaWidth();
      linewidth -= labelareawidth;

      if(this.titlecomp)
        this.titlecomp.setWidth(labelareawidth);
    }

    this.distributeSizeProps('width', linewidth, this.getVisibleItems(), true);
  }

, applySetHeight:function()
  {
    var lineheight = this.height.set;
    this.debugLog("dimensions", "setheight=" + this.height.set + ", lineheight=" + lineheight + ", margins=" + this.height.marginbefore + "+" + this.height.marginafter);

    if (this.titlecomp)
      this.titlecomp.setHeight(lineheight);

    this.getVisibleItems().invoke('setHeight',lineheight);
  }

, readdComponent: function(comp)
  {
    //console.log("Replace panel item '" +comp.name + "'");
    if(!this.owner)
    {
      console.error("CANNOT READD NODE: owner == null! " + comp.name,this);
      return; //FIXME
    }
    var newcomp = this.owner.addComponent(this, comp.name);
    var newel = newcomp.getNode();

    // If already rendered, live replace
    dompack.replaceWith(comp.getNode(), newel);

    var tokill = comp.getNode().retrieve("wh-ui-replacedby");
    if(tokill)
      tokill.destroy();

    this.items[this.items.indexOf(comp)] = newcomp;
  }

, relayout:function()
  {
    this.node.setStyle("height", this.height.set);

    if(this.layout == "form")
    {
      //this.titlenodeholder.setStyle("width", this.parentcomp.getLabelAreaWidth() - this.width.marginbefore);
      if (this.titlecomp)
        this.titlecomp.relayout();
      else
      {
        var labelarea = this.parentcomp.getLabelAreaWidth();
        if(labelarea)
          this.node.setStyle("padding-left", this.parentcomp.getLabelAreaWidth() + $todd.settings.spacerwidth);
      }
    }

    this.getVisibleItems().each(function(item, idx)
    {
      item.relayout(!this.block);
    }, this);
  }

});


/****************************************************************************************************************************
 *                                                                                                                          *
 *  INLINE BLOCK                                                                                                            *
 *                                                                                                                          *
 ****************************************************************************************************************************/


$todd.ObjInlineBlock = new Class(
{ Extends: $todd.ObjLayout
, componenttype: "inlineblock"
, borders: {}

/****************************************************************************************************************************
* Initialization
*/

, initialize: function(parentcomp, data, replacingcomp)
  {
    this.parent(parentcomp, data, replacingcomp);
    this.backgroundcolor = data.backgroundcolor;
    this.backgroundimages = data.backgroundimages;
    this.title = data.title;
    this.spacers = data.spacers;
    this.borders = data.borders;

    //ADDME can't we embed Block items directly instead of wrapping them into lines?
    this.lines = [];
    if(data.lines)
      data.lines.each(function(srcline,i)
    {
      srcline.target = this.name + "#line$" + i;
      srcline.destroywithparent = true;
      var line = new $todd.ObjPanelLine(this, srcline, null, null);
      this.lines.push(line);

      if(line.title)
      {
        var titlecomp = new $todd.ObjText(line, { value: line.title ? line.title + ':' : ''
                                                , labelfor: line.titlelabelfor
                                                , target: srcline.target + "#linelabel"
                                                , destroywithparent: true
                                                });

        if(line.layout=='form') //we need to keep the title separated
          line.titlecomp = titlecomp;
        else
          line.items.push(titlecomp);
      }

      if(srcline.items)
        srcline.items.each(function(srcitem, idx)
      {
        var newcomp;
        if (srcitem.title)
        {
          newcomp = new $todd.ObjText(line, { value: srcitem.title ? srcitem.title + ':' : ''
                                            , labelfor: srcitem.labelfor
                                            , target: srcline.target + "#label$" + idx
                                            , destroywithparent: true
                                            });
        }
        else
        {
          newcomp = this.owner.addComponent(line, srcitem.item);
        }

        if(newcomp)
        {
          line.items.push(newcomp);
        }
      }, this);
    }, this);

    this.setMinToAbs(this.height);
    this.setMinToAbs(this.width);

    // Build our DOM
    this.buildNode();
  }


/****************************************************************************************************************************
* Component management
*/

, getVisibleChildren:function()
  {
    var children=[];
    this.lines.each(function(line)
      {
        if(line.titlecomp)
        {
          children.push(line.titlecomp);
        }
      });
    children.append(this.lines);
    return children;
  }

, readdComponent: function(comp)
  {
    for(var i=0;i<this.lines.length;++i)
      if(this.lines[i].items.indexOf(comp)!=-1)
      {
        this.lines[i].readdComponent(comp);
        return;
      }
    return console.error('Child ' + comp.name + ' not inside the inline block is trying to replace itself');
  }

/****************************************************************************************************************************
* DOM
*/

  // Build the DOM node(s) for this component
, buildNode: function()
  {
    this.node = new Element("t-inlineblock", { "data-name": this.name });
    this.node.addEventListener('mousedown', this.mouseDownNoFocusSteal.bind(this));

    this.nodearea = new Element("div", {"class":"panel-area"}).inject(this.node);
    this.node.store("todd", this);

    updateNodeBackground(this.node, this.backgroundcolor, this.backgroundimages);

    Array.each(['top','bottom','left','right'], function(dir)
    {
      if(this.borders && this.borders[dir])
        this.node.classList.add("border-" + dir);
    }.bind(this));

    this.lines.invoke('buildNode');
    this.lines.each(function(line) { this.nodearea.appendChild(line.node); }, this);
  }


/****************************************************************************************************************************
* Dimensions
*/

, getLabelAreaWidth:function() //figure out the longest form-layout line label, and apply it to all lines. as labelwidth isn't open to discussion, apply immediately
  {
    // Calculate the width of the label area if we have form lines.
    var labelareawidth = 0;
    this.lines.each(function(line)
      {
        if(line.titlecomp)
        {
          if(line.titlecomp.width.min)
            labelareawidth = Math.max(labelareawidth, line.titlecomp.width.min);
        }
      });

    return labelareawidth;
  }

, calculateDimWidth: function()
  {
    // contentwidth is the width of the widest line
    var headerwidth = 0;

    //Prepare line calculation: we first need their label widths, then lines can do their actual calculations
    this.setSizeToMaxOf('width', this.lines);
    this.width.overhead = (this.borders && this.borders.left ? $todd.settings.border_left : 0) +
                        + (this.borders && this.borders.right ? $todd.settings.border_right : 0);

    this.width.min += this.width.overhead;
    this.width.calc += this.width.overhead;

    this.width.min = Math.max(this.width.min, headerwidth);
    this.width.calc = Math.max(this.width.calc, headerwidth);

/* ADDME?
    contentwidth += this.width.marginbefore + this.width.marginafter;
    contentminwidth += this.width.marginbefore + this.width.marginafter;

    this.width.calc = Math.max(contentwidth, width);
    this.width.min = contentminwidth;
    */
  }

, applySetWidth: function()
  {
    //the inner width/height is what we present to our contents, and may exceed set width/height if we can scroll ourselves
    this.innerwidth = this.width.set - this.width.overhead;

    var setwidth = this.innerwidth;
    this.debugLog("dimensions", "width: calc=" + this.width.calc + ", set=" + this.width.set + ", overhead=" + this.width.overhead + ", effective=" + setwidth);

    this.lines.invoke('setWidth', setwidth);
  }

, calculateDimHeight: function()
  {
    // Calculate needed size
    this.setSizeToSumOf('height', this.lines);
    this.childrencalcheight = this.height.calc;

    this.height.overhead = (this.borders && this.borders.top ? $todd.settings.border_top : 0) +
                         + (this.borders && this.borders.bottom ? $todd.settings.border_bottom : 0);

    this.height.min += this.height.overhead;
    this.height.calc += this.height.overhead;
  }

, applySetHeight: function()
  {
    this.innerheight = this.height.set - this.height.overhead;

    this.debugLog("dimensions", "calc=" + this.height.calc + ", set height=" + this.height.set + " ,effective=" + this.innerheight);

    this.distributeSizeProps('height', this.innerheight, this.lines, false);
  }

, relayout: function()
  {
    this.debugLog("dimensions", "relayouting set width=" + this.width.set + ", set height="+ this.height.set);

    // Set outer width, including border (we have box-sizing: border-box!)
    this.node.setStyles({width: this.width.set, height: this.height.set});

    // Check if the node is big enough to display the whole background image
    if (this.node[bgstyle])
    {
      if ((this.node[bgstyle].width && this.node[bgstyle].width > this.width.set)
          || (this.node[bgstyle].height && this.node[bgstyle].height > this.height.set))
        this.node.classList.add("bgstyle-responsive");
      else
        this.node.classList.remove("bgstyle-responsive");
    }

    this.lines.invoke('relayout');
  }
});


/****************************************************************************************************************************
 *                                                                                                                          *
 *  SPACER                                                                                                                  *
 *                                                                                                                          *
 ****************************************************************************************************************************/


$todd.ObjSpacer = new Class(
{ Extends: $todd.ObjLayout
, componenttype: "spacer"

/****************************************************************************************************************************
* Initialization
*/

, initialize: function(parentcomp, data, replacingcomp)
  {
    this.parent(parentcomp, data, replacingcomp);
    this.buildNode();
  }


/****************************************************************************************************************************
* DOM
*/

, buildNode:function()
  {
    this.node = new Element("t-spacer", { "data-name": this.name
                                        });
    this.node.store("todd", this);
  }


/****************************************************************************************************************************
* Dimensions
*/

, calculateDimWidth: function()
  {
    var width = $todd.ReadSetWidth(this.width);
    this.width.calc = width;
    this.width.min = 0;
  }

, applySetWidth:function()
  {
    this.node.setStyle("width", this.width.set);
  }

, calculateDimHeight: function()
  {
    this.height.calc = this.node.getSize().y;
    this.height.min = 0;
  }

, relayout: function()
  {
    this.debugLog("dimensions", "relayouting set width=" + this.width.set + ", set height="+ this.height.set);
    this.node.setStyles({ width: this.width.set
                        , height: this.height.set
  //                      , "margin-left": this.width.marginbefore
  //                      , "margin-top": this.getVerticalPosition()
                        });
  }

});


/****************************************************************************************************************************
 * Export the components
 */
exports.components = { panel: $todd.ObjPanel
                     , inlineblock: $todd.ObjInlineBlock
                     , spacer: $todd.ObjSpacer
                     };



// WEBPACK FOOTER //
// /opt/wh/whtree/modules/tollium/web/ui/js/panel.es